import React from 'react';

export default function FieldDropdownLazyLoading_FormValueLoading(props:any) {

    const size = _.get(props.configOptions, 'size', '36')

    const classes = Classes("ui5-field-form-editable ", 'h-{0}'.f(size), props.className)

    return (
        <React.Fragment>
            <div className={classes} onClick={props.onClick}>
                {_.get(props.field.components, 'ValueIcon', false)}
                <img src={gdConfig.assetsPath + '/skin/common/loader/img-loading.gif'} height={14} width={14} />
                <div className="ui5-txt-no-accent-default txt-truncate m-l-10">Loading...</div>
            </div>
            {props.children}
        </React.Fragment>
    )
}